import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/attachment-photo.js";
import "@ui5/webcomponents-icons/dist/chain-link.js";
import "@ui5/webcomponents-icons/dist/download-from-cloud.js";
import "@ui5/webcomponents-icons/dist/machine.js";
import "@ui5/webcomponents-icons/dist/print.js";
import "@ui5/webcomponents-icons/dist/settings.js";

import { devicePermissions, deviceSettingsGroup } from "./permissions";

/** Device Agent entries of the navigation registry (group `devices`, ADR-0014). */
export const deviceNavigation: readonly NavigationEntry[] = [
  {
    key: "device.agents",
    labelKey: "nav.deviceAgents",
    icon: "machine",
    path: "/device/agents",
    permission: devicePermissions.agentView,
  },
  {
    key: "device.pairing",
    labelKey: "nav.devicePairing",
    icon: "chain-link",
    path: "/device/pairing",
    permission: devicePermissions.agentPair,
  },
  {
    key: "device.jobs",
    labelKey: "nav.deviceJobs",
    icon: "print",
    path: "/device/jobs",
    permission: devicePermissions.jobView,
  },
  {
    key: "device.releases",
    labelKey: "nav.deviceReleases",
    icon: "download-from-cloud",
    path: "/device/releases",
    permission: devicePermissions.releaseView,
  },
  {
    key: "device.scans",
    labelKey: "nav.deviceScans",
    icon: "attachment-photo",
    path: "/device/scans",
    permission: devicePermissions.scanView,
  },
  {
    key: "device.settings",
    labelKey: "nav.deviceSettings",
    icon: "settings",
    path: `/platform/settings/${deviceSettingsGroup}`,
    permission: devicePermissions.profileView,
  },
  {
    key: "device.profiles",
    labelKey: "nav.deviceProfiles",
    icon: "machine",
    path: "/platform/device-profiles",
    permission: devicePermissions.profileView,
  },
];
